import { useEffect, useState } from "react";
import { CircularProgress, Dialog, DialogActions, Paper } from "@mui/material";
import { toast } from "react-toastify";

import { MyButton } from "../MyButton";
import { IEmployee } from "../../Interfaces/interfaces";
import { EmployeeService } from "../../Services/EmployeeService";
import { LinkEmployeeRegister } from "../../models/employeeType";
import { TypeLinkRegister } from "../../enum/enums";
import { useEncrypt } from "../../hooks/useEncryptLink";

type Props = {
    show: boolean;
    employee?: IEmployee;
    eventId: number;
    companyName: string;
    handleClose: () => void;
}

export function DialogLinkFotoFuncionario(props: Props) {
    const [loading, setLoading] = useState(false);
    const [link, setLink] = useState('');
    const [failed, setFailed] = useState(false);

    const { encrypt } = useEncrypt();

    const generateLink = async (employee: IEmployee) => {
        setLoading(true);
        setFailed(false);
        setLink('');

        const enabled = await new EmployeeService().enableToRegisterAsync(employee.employeeId);

        if (enabled) {
            const data: LinkEmployeeRegister = {
                eventId: props.eventId,
                companyId: employee.companyId,
                companyName: props.companyName,
                employeeId: employee.employeeId,
                typeLink: TypeLinkRegister.AtualizarFoto
            };

            const encryptedMessage = encrypt(data);
            setLink(`${process.env.REACT_APP_BASE_URL}credenciamento/${encodeURIComponent(encryptedMessage)}`);
        } else {
            setFailed(true);
        }

        setLoading(false);
    }

    useEffect(() => {
        if (props.show && props.employee)
            generateLink(props.employee);
    }, [props.show, props.employee?.employeeId]);

    const copyLink = async () => {
        try {
            await navigator.clipboard.writeText(link);
            toast.success('Link copiado');
        } catch {
            toast.error('Não foi possível copiar. Selecione o link e copie manualmente.');
        }
    }

    const close = () => {
        setLink('');
        setFailed(false);
        props.handleClose();
    }

    return (
        <Dialog maxWidth={'lg'} open={props.show} onClose={close}>
            <header className="header">
                <p className="text-white text-center py-2 px-4 text-xl">
                    Link de atualização de foto — {props.employee?.fullName}
                </p>
            </header>

            <div className="w-full my-4 px-5">
                {loading && (
                    <div className="flex justify-center py-4">
                        <CircularProgress />
                    </div>
                )}

                {!loading && link && (
                    <Paper elevation={10} className='d-flex justify-content-center px-4 py-4 rounded'>
                        <span style={{ inlineSize: '100%', overflowWrap: 'break-word' }}>
                            {link}
                        </span>
                    </Paper>
                )}

                {!loading && failed && (
                    <p className="text-center text-red-600 py-4">Não foi possível gerar o link.</p>
                )}
            </div>

            <DialogActions className="gap-2 px-5 pb-4">
                <MyButton onClick={copyLink} disabled={!link || loading}>
                    Copiar
                </MyButton>
                <MyButton onClick={close}>
                    Fechar Janela
                </MyButton>
            </DialogActions>
        </Dialog>
    )
}
